import getUri, { getNonApiUri, getPageHelpUri } from '../utils/getUri';

export default function getApiConstants(helpPageUrl) {
    return {
        auditLogUri: getUri('AuditLogApi'),
        canModifyLandingPage: getUri('DashboardMetric/CanModifyLandingPage'),
        deleteSavedDashboard: (dashboardKey) =>
            getUri(
                `DashboardMetric/RemoveSavedDashboard?parameterId=${dashboardKey}`
            ),
        downloadDashboard: getUri('DashboardMetric/Download'),
        getAllDashboardConfigurations: getUri(
            'DashboardMetric/GetAllDashboardConfigurations'
        ),
        getAllSavedFilters: getUri('DashboardMetric/GetAllSavedFilters'),
        getDashboardConfigurationUri: (dashboardKey) =>
            getUri(
                `DashboardMetric/GetDashboardConfiguration?dashboardKey=${dashboardKey}`
            ),
        getLandingPageConfigurationUri: getUri(
            'DashboardMetric/GetLandingPageConfiguration'
        ),
        getNonApiUri,
        getSavedDashboards: (dashboardKey) =>
            getUri(
                `DashboardMetric/GetSavedDashboards?parameterId=${dashboardKey}`
            ),
        getSharedUrl: (id) => getUri(`SharedUrl/GetSharedUrlById?id=${id}`),
        getShareableUri: (externalLink) =>
            `${window.location.origin}${(`/Dashboard/${externalLink}`)}`,
        getSystemLinks: getUri('SystemConfiguration/GetSystemLinks'),
        getUserFavorites: getUri('SiteMapApi/GetUserFavorites'),
        logMessageUri: getUri('LoggingWebError/LogMessage'),
        metricDataUri: getUri('DashboardMetric/GetMetricData'),
        pageHelpUri: (onlineHelpId) => getPageHelpUri({ helpPageUrl, onlineHelpId }),
        saveDashboard: getUri('DashboardMetric/SaveDashboard'),
        saveSharedUrl: getUri('SharedUrl/SaveSharedUrl'),
        saveUserLandingPage: getUri('DashboardMetric/SaveUserLandingPage'),
        selectDashboardUri: getUri('DashboardMetric/GetAllDashboardConfigurations'),
        selectOptionsUri: getUri('SelectOptionApi/GetCriteriaValues'),
        thresholdsUri: getUri('DashboardMetric/GetAllThresholds'),
        updateDashboardUri: getUri('DashboardMetric/UpdateDashboardConfiguration'),
        getKpiTargetsUri: getUri('DashboardMetric/GetKpiTargets'),
        pdfExportUri: getUri('DashboardMetric/PdfExport'),
        getSystemManifestUri: getUri('SystemManifestApi/GetSystemManifest'),
        getUserFeatureTokensUri: getUri('UserFeatureTokensApi/GetUserFeatureTokens')
    }
};
